import { MessageCircle } from "lucide-react";
import { imgUrl } from "../api";
import { useSettings } from "../context/SettingsContext";

export default function About() {
  const { settings, homepage, whatsappLink } = useSettings();
  const about = homepage.about || {};
  const paragraphs = String(about.body || "").split(/\n\s*\n/).filter(Boolean);

  return (
    <main className="about-page" data-testid="about-page">
      <header className="about-hero">
        <span className="eyebrow">About</span>
        <h1>{about.heading || "Where Indian heritage is reimagined through a contemporary lens."}</h1>
      </header>

      <section className={`about-story ${about.image ? "has-image" : ""}`}>
        {about.image && (
          <figure className="about-image">
            <img src={imgUrl(about.image)} alt="Lalita Soujanya contemporary Indian craftsmanship" />
          </figure>
        )}
        <div className="about-copy">
          {paragraphs.map((paragraph, index) => (
            <p className={index === 0 ? "about-intro" : ""} key={paragraph.slice(0, 48)}>{paragraph}</p>
          ))}
          <div className="about-principles" aria-label="Design principles">
            <div><span className="eyebrow">Rooted in</span><strong>Indian craftsmanship</strong></div>
            <div><span className="eyebrow">Expressed through</span><strong>Contemporary silhouettes</strong></div>
          </div>
          <a href={whatsappLink("Hi Lalita Soujanya, I'd like to know more about your collection.")} target="_blank" rel="noreferrer"
            className="btn btn-primary" data-testid="about-whatsapp-cta">
            {settings.whatsapp_button_label || "Enquire about the collection"} <MessageCircle size={16} />
          </a>
        </div>
      </section>
    </main>
  );
}
